export default __webpack_public_path__ + "static/media/banner-dress-img.c944491e.png";